<script>
import { state, removeMessage } from '@/config/store';

export default {
  data() {
    return {
      shared: state,
    };
  },

  methods: {
    removeMessage,
  },
};
</script>

<template>
  <div v-show="shared.messages.length" class="messages overflow-auto p-5 w-full mxh-full">
    <p
      v-for="m in shared.messages"
      :key="m.id"
      class="flex jcontent-space-between mxw-520 mx-auto p-3 mt-3 color-white radius shadow-base"
      :class="{
        'bgc-grey': m.type === 'info',
        'bgc-danger': m.type === 'danger',
        'bgc-success': m.type === 'success',
      }">
      {{ m.text }}
      <button
        v-once
        type="button"
        class="flex-none color-white bg-none border-0 cursor-pointer"
        :aria-label="$t('close')"
        @click="removeMessage(m)">
        <ion-icon class="fsize-5" name="close-outline" />
      </button>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.messages {
  overflow: auto;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
}
</style>
